// «Расшифровываю голосовое…» — пока голосовое этой беседы в работе.
//
// Два источника, берём больший (это одни и те же записи, не сумма):
// своя незавершённая загрузка (lib/voiceUpload.ts) и `voicePending` с сервера —
// его видно и после возврата в беседу, и после перезагрузки, и на телефоне.

import { useVoiceUploads } from '../lib/voiceUpload'
import { usePane } from '../store/logStore'
import './composer.css'

export default function VoicePending({ sessionId }: { sessionId: string }) {
  const local = useVoiceUploads((s) => s.count[sessionId] ?? 0)
  const server = usePane(sessionId, (s) => s.session?.voicePending ?? 0)
  const n = Math.max(local, server)
  if (n <= 0) return null
  return (
    <div className="ab-voicebar" role="status">
      <div className="ab-recdot ab-recdot--still" />
      <span className="ab-rectext">
        {n > 1 ? `расшифровываю голосовые (${n})` : 'расшифровываю голосовое'} — уйдёт агенту само
      </span>
    </div>
  )
}
